<script setup lang="ts">
  import { TextProps } from "./types";

  const {
    as = "span",
    font = "body-regular-16",
    color = "primary",
    uppercase = false,
    wrap = true,
    ellipsis = false,
  } = defineProps<TextProps>();
</script>

<template>
  <component
    :is="as"
    :class="[
      'text',
      `text-${color}`,
      font,
      { 'text--uppercase': uppercase, 'text--wrap': wrap, 'text--ellipsis': ellipsis },
    ]"
  >
    <slot />
  </component>
</template>

<style scoped>
  .text {
    white-space: nowrap;
  }
  .text-primary {
    color: var(--sf-base-text-primary);
  }
  .text-secondary {
    color: var(--sf-base-text-secondary);
  }
  .text-tertiary {
    color: var(--sf-base-text-tertiary);
  }
  .text-white {
    color: var(--sf-base-text-white);
  }
  .text-success {
    color: var(--sf-base-text-success);
  }
  .text-warning {
    color: var(--sf-base-text-warning);
  }
  .text-error {
    color: var(--sf-base-text-error);
  }
  .text-size-success {
    color: var(--sf-size-text-success);
  }
  .text-size-warning {
    color: var(--sf-size-text-warning);
  }
  .text-size-error {
    color: var(--sf-size-text-error);
  }

  .text--uppercase {
    text-transform: uppercase;
  }

  .text--wrap {
    white-space: wrap;
  }
  .text--ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
